import { motion } from "framer-motion";
import { STEPS, IMAGES } from "./data";

export const HowWeWork = () => {
  return (
    <section id="how-we-work" className="py-20 md:py-32 bg-[#F9FAFB] border-y border-gray-200" data-testid="how-we-work-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <span className="text-sm text-gray-500 uppercase tracking-widest font-semibold">How We Work</span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">
              A structured process, from request to delivery.
            </h2>
            <p className="mt-5 text-base sm:text-lg text-gray-600 leading-relaxed">
              We remove the guesswork from freight and supplier follow-up. Every shipment follows a structured path with
              clear communication, active tracking, and timely updates — so you always know where things stand.
            </p>
            <div className="mt-8 overflow-hidden border border-gray-200">
              <img src={IMAGES.warehouse} alt="Warehouse operations" className="w-full h-56 object-cover" />
            </div>
          </div>

          <div className="lg:col-span-7 relative">
            {/* Abstract vertical route line */}
            <svg className="absolute left-[27px] top-4 bottom-4 hidden sm:block" width="2" height="100%" preserveAspectRatio="none">
              <line x1="1" y1="0" x2="1" y2="100%" stroke="#E5E7EB" strokeWidth="2" strokeDasharray="4 6" />
            </svg>
            <div className="space-y-8">
              {STEPS.map((s, i) => (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="relative flex gap-6"
                  data-testid={`work-step-${i}`}
                >
                  <div className="relative z-10 shrink-0 w-14 h-14 flex items-center justify-center bg-[#001E52] text-white font-heading font-bold text-lg">
                    {s.n}
                  </div>
                  <div className="pt-1.5">
                    <h3 className="font-heading text-xl font-semibold text-gray-900">{s.title}</h3>
                    <p className="mt-2 text-[15px] text-gray-600 leading-relaxed max-w-md">{s.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
